import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { Chart } from 'react-google-charts';
import MetricSelector from './MetricSelector';
import DateSelector from './DateSelector';
import EventsApiClient from '../stores/EventsApiClient';

export default class MetricChart extends Component {

  constructor(props){
    super(props);
    this.state = {};
    this.state.chart = this.makeChart([]);
  }

  makeChart(events) {
    var rows = [];
    
    for (var i = 0; i < events.length ; i++) {
      rows.push([new Date(events[i].Date), events[i].Value]);
    }
    
    if (events.length === 0) {
      rows = [[new Date('2000-01-01'), 0]];
    }

    return {
      "chartType": "LineChart",
      "columns": [{
        "label": "time",
        "type": "datetime"
      }, {
        "label": "Value",
        "type": "number"
      }],
      "rows": rows,
      "options": {
        "legend": {position: 'none'},
        "hAxis": {
          "title": "Time"
        },
        "vAxis": {
          "title": "Value"
        }
      },
      "width": "100%"
    };
  }

  handleEventChange = (e) => {
    var state = Object.assign({}, this.state);
    state.server = e.target.state.server;
    state.category = e.target.state.category;
    state.monitor = e.target.state.monitor;
    this.setState(state, this.triggerChange);
  }

  handleDateChange = (e) => {
    var state = Object.assign({}, this.state);
    state.date =  new Date(e.target.state.year, e.target.state.month, e.target.state.day);
    this.setState(state, this.triggerChange);
  }

  triggerChange = (e) => {

    var self = this;
    var state = Object.assign({}, this.state);

    if (this.state.monitor !== '' && this.state.date != null) {

      state.hidden = true;
      self.setState(state);

      new EventsApiClient().query(
        this.state.server,
        this.state.category,
        this.state.monitor,
        this.state.date.toISOString(),
        this.addDays(this.state.date, 1).toISOString()).then(function (response) {

          state.hidden = false;
          state.chart = self.makeChart(response.data);
          self.setState(state);

      });
    } else {

      state.hidden = false;
      state.chart = self.makeChart([]);
      self.setState(state);

    }

  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  render() {
    return (
      <div>

        <MetricSelector onChange={this.handleEventChange}/>

        <div className="chart-container">
          <div className={this.state.hidden ? "hidden" : ""}>
            <Chart
              chartType={this.state.chart.chartType}
              columns={this.state.chart.columns}
              rows={this.state.chart.rows}
              options={this.state.chart.options}
              width={this.state.chart.width}
              height="600px"
              legend_toggle
            />
          </div>
        </div>


        <div className="pad20">
          <div className="row">
            <div className="col-md-4">
              <DateSelector onChange={this.handleDateChange}/>
            </div>
            <div className="col-md-4">
              <Button onClick={this.triggerChange}>↻ refresh</Button>
            </div>
            <div className="col-md-4">
            </div>
          </div>
        </div>

      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/MetricChart.js